import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetPartitionDetailCB} from "../../ope/partition/GetPartitionDetailCB";
import {PutPartitionCB} from "../../ope/partition/PutPartitionCB";
import {DelPartitionCB} from "../../ope/partition/DelPartitionCB";
import {UpdateParentPartitionCB} from "../../ope/partition/UpdateParentPartitionCB";
import {GetPartitionHierarchyCB} from "../../ope/partition/GetPartitionHierarchyCB";

@Injectable({
  providedIn: 'root'
})
export class PartitionOpeService extends BaseOPEService {

  public getPartitionDetail(cb: GetPartitionDetailCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getPartitionHierarchy(cb: GetPartitionHierarchyCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putPartition(cb: PutPartitionCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delPartition(cb: DelPartitionCB): Promise<any> {
    return this.execOPE(cb);
  }

  public updateParentPartition(cb: UpdateParentPartitionCB): Promise<any> {
    return this.execOPE(cb);
  }

}
